import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class ExpireSpanComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      data_span: {},
    };
  }

  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      data_span: newProps.data_span,
      loaded: 1,
    });
  }


  render() {
    var self = this;
    return (
<div>
  {Object.keys(self.state.data_span).map(function(k) {
    return (
      <div>
        <span className={self.state.data_span[k].expire_status == 'Válido' ? "label label-success" : self.state.data_span[k].expire_status == 'Vencido' ? "label label-danger" : "label label-default"}>
          {self.state.data_span[k].name + ' - ' + self.state.data_span[k].expiration}
        </span>
        <br/>
      </div>
    );
  })}
</div>
    );
  }
}

export default ExpireSpanComponent;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/ExpireSpanComponent.js